/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { SectionGrid } from "frontend/src/components/Layout"
import { Logo } from "frontend/src/components/Logo"

// desktop component for retailer logos
function RetailerLogosDesktop({ headline, backgroundColor, fontColor, retailerLogos }) {
  // render function
  return (
    <SectionGrid
      sx={{
        display: ["none", "none", "grid"],
        backgroundColor: "inherit",
        color: fontColor,
      }}
    >
      <p
        sx={{
          fontFamily: "heading",
          color: fontColor,
          fontWeight: "regular",
          fontSize: "38px",
          lineHeight: "44px",
          letterSpacing: "-1.24px",
          backgroundColor: "inherit",
          gridColumn: "3 / span 1",
          textAlign: "center",
          mb: 8,
        }}
      >
        {headline}
      </p>
      <div
        sx={{
          width: "calc(100% - 40px)",
          margin: "0 20px",
          gridColumn: "2 / span 3",
          color: fontColor,
          backgroundColor: "inherit",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-around",
          alignItems: "center",
        }}
      >
        {retailerLogos &&
          retailerLogos.map((singleLogo, index) => {
            const { logo } = singleLogo
            return (
              <Logo name={logo} sx={{ height: ["unset", "unset", "46px", "55px"], px: 2, my: 4 }} />
            )
          })}
      </div>
    </SectionGrid>
  )
}

// mobile version of retailer logo component
function RetailerLogosMobile({ headline, backgroundColor, fontColor, retailerLogos }) {
  // render function
  return (
    <SectionGrid
      sx={{
        display: ["block", "block", "none"],
        backgroundColor: backgroundColor,
      }}
    >
      <div
        sx={{
          color: fontColor,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignItems: "center",
          backgroundColor: "inherit",
        }}
      >
        <p
          sx={{
            fontFamily: "heading",
            fontWeight: 500,
            fontSize: "28px",
            lineHeight: "30px",
            letterSpacing: "-1.24px",
            color: fontColor,
            mb: 7,
            backgroundColor: "inherit",
            textAlign: "center",
          }}
        >
          {headline}
        </p>
      </div>
      <div
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-around",
          alignItems: "center",
          backgroundColor: "inherit",
        }}
      >
        {retailerLogos &&
          retailerLogos.map((singleLogo, index) => {
            const { logo } = singleLogo
            return <Logo name={logo} sx={{ height: "35px", mx: 7, my: 4 }} />
          })}
      </div>
    </SectionGrid>
  )
}

function RetailerLogos({
  headline,
  backgroundColor,
  fontColor,
  retailerLogos,
  retailerLogosMobile,
}) {
  // keep only logos to be shown on desktop/mobile devices
  return (
    <div sx={{ backgroundColor: backgroundColor, py: [5, 8] }}>
      <RetailerLogosDesktop
        headline={headline}
        backgroundColor={backgroundColor}
        fontColor={fontColor}
        retailerLogos={retailerLogos}
      />
      <RetailerLogosMobile
        headline={headline}
        backgroundColor={backgroundColor}
        fontColor={fontColor}
        retailerLogos={retailerLogosMobile}
      />
    </div>
  )
}

export { RetailerLogos }
